import { Injectable } from '@angular/core';
import { DataCoreService } from '../../../../services/data-core.service';

@Injectable(

)
export class CtlSasAboneKisiAramaService {

  constructor(private dataCoreService: DataCoreService) {}

  getData(control: any) {
          const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);
          dataSource.select([]);
          return dataSource;
  }}
